import React from 'react';
import EmptyState from '../EmptyState';
import NoResultsBoundary from '../NoResultsBoundary';
import './style.scss';
const SearchResultsList = props => {
  const {
    hits,
    renderItem,
    emptyState,
    headerElement
  } = props;
  return /*#__PURE__*/React.createElement(NoResultsBoundary, {
    fallback: /*#__PURE__*/React.createElement(EmptyState, {
      emptyState: emptyState
    })
  }, /*#__PURE__*/React.createElement(React.Fragment, null, headerElement, /*#__PURE__*/React.createElement("ol", {
    className: "Searchkit__Results"
  }, hits.map(hit => /*#__PURE__*/React.createElement("li", {
    key: hit.objectID
  }, renderItem(hit))))));
};
export default SearchResultsList;